import { Fields } from './useValidator/interfaces';

// TODO should just be a util

const useErrorCount = (fields: Fields): number => {
    return Object.entries(fields).reduce((acc, [key, fieldState]) => {
        return key === 'form' ? acc : acc + (fieldState.invalid === 'invalid' ? 1 : 0);
    }, 0);
};

export default useErrorCount;
